module.exports = __webpack_public_path__ + "media/ritmoes.20b8a1be.mp4";